import React from 'react';
import { Container, ContainerPreview, MockupDesktop } from './DesktopPreview.styles';
import desktop from '../../../../assets/images/mockup-monitor.png';
import { Preview } from '../Preview';

export function DesktopPreview(): JSX.Element {
  return (
    <Container>
      <MockupDesktop src={desktop} />
      <ContainerPreview>
        <Preview />
      </ContainerPreview>
    </Container>
  );
}
